import { Permissions, Pagination } from '@factorin/domain';

import { withUrl, list, Request, post, put, remove, ItemRequest } from '../rest';


export type PermissionGroupBody = {
    Name: string;
}

export type PermissionsIds = {
    permissionIds: string[];
}

const permissionGroupsPart = withUrl('permissionGroups');

export const permissionGroups = {
    ...list<Permissions.Permission, Pagination.Request>(permissionGroupsPart()),

    create: post<Request.Body<PermissionGroupBody>, void>(
        ({ body }) => permissionGroupsPart({
            body,
        }),
    ),

    addPermission: put<ItemRequest & PermissionsIds, void>(
        ({ id, permissionIds }) => permissionGroupsPart({
            path: `${id}/permissions`,
            query: { permissionIds },
        }),
    ),
    removePermission: remove<ItemRequest & PermissionsIds, void>(
        ({ id, permissionIds }) => permissionGroupsPart({
            path: `${id}/permissions`,
            query: { permissionIds },
        }),
    ),
};
